import React from 'react'
import BookingPaymentSuccessState from './BookingPaymentSuccessState'
import MemberBookingSuccess from '../components/MemberBookingSuccess'

export default function MemberGolfBookingSuccessPage({ clubCode }) {
  return <BookingPaymentSuccessState clubCode={clubCode} module="golf">
    <MemberBookingSuccess clubCode={clubCode} module="golf" />
  </BookingPaymentSuccessState>
}
